
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
  props: {
    pageData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
})
export default class PoliticaPrivacidadeView extends Vue {}
